import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import SurveyBody from './survey-body';

class ExceededWorkingHoursSurveyModal extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired,
    scrollCalendar: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };
  }

  reject = () => {
    this.props.callback(false);
  }

  render = () => {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}>
        <div className='modal-content'>
          <button className='close' onClick={this.reject}></button>
          <SurveyBody
            callback={this.props.callback}
            scrollCalendar={this.props.scrollCalendar}
          />
        </div>
      </Modal>
    );
  }
}

export default ExceededWorkingHoursSurveyModal;



/** WEBPACK FOOTER **
 ** ./src/components/exceeded-working-hours-survey-modal/exceeded-working-hours-survey-modal.js
 **/